import authSagas from './auth';
import approvalSagas from './approval';
import catalogueSagas from './catalogue';
import cartSagas from './cart';
import checkoutSagas from './checkout';
import orderSagas from './order';
import contractSagas from './contract';
import accountSagas from './account';
import commonSaga from './common';
import reserveNumberSagas from './reservenumber';
import checkEligibilitySagas from './checkeligibility';
import numberShareSagas from './numberShare';
import { fork, all } from 'redux-saga/effects';
import transferLineSagas from './transfermobileline';
import changeMobileNoSagas from './changemobileno';
import serRoadshowSagas from './serroadshow';
import promoConfigurationSagas from './promoConfigs';
import numberPort from './numberPort';
import simactivation from './simactivation';
import eform from './eform'

export default function* root() {
  yield all([
    fork(authSagas),
    fork(approvalSagas),
    fork(catalogueSagas),
    fork(orderSagas),
    fork(cartSagas),
    fork(checkoutSagas),
    fork(contractSagas),
    fork(accountSagas),
    fork(commonSaga),
    fork(reserveNumberSagas),
    fork(checkEligibilitySagas),
    fork(numberShareSagas),
    fork(transferLineSagas),
    fork(changeMobileNoSagas),
    fork(serRoadshowSagas),
    fork(promoConfigurationSagas),
    fork(numberPort),
    fork(simactivation),
    fork(eform)
  ]);
}
